var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.17 5.39062L19 10.2206V19.3906H5V5.39062H14.17ZM14.17 3.39062H5C3.9 3.39062 3 4.29062 3 5.39062V19.3906C3 20.4906 3.9 21.3906 5 21.3906H19C20.1 21.3906 21 20.4906 21 19.3906V10.2206C21 9.69063 20.79 9.18062 20.41 8.81063L15.58 3.98062C15.21 3.60062 14.7 3.39062 14.17 3.39062ZM7 15.3906H17V17.3906H7V15.3906ZM7 11.3906H17V13.3906H7V11.3906ZM7 7.39062H14V9.39062H7V7.39062Z",
    fill: "#397431"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDocuments);
export default __webpack_public_path__ + "static/media/company-documents.65b8fa2ab96fbc1162c28e101637fc93.svg";
export { ForwardRef as ReactComponent };